import { render, staticRenderFns } from "./PageConnectWearableRedirect.vue?vue&type=template&id=df9c61e4"
import script from "./PageConnectWearableRedirect.vue?vue&type=script&lang=js"
export * from "./PageConnectWearableRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports